import { API } from "@/lib/api";

// Source domains whose images are hot-link protected (or otherwise fail to load
// directly in the browser). These are routed through the backend image proxy.
const PROXY_ROOTS = [
  "apartadox.com", "mulheresvip.net", "gostosas.pt", "classificadosx.net",
  "somassagens.com", "docemassagem.com", "portuas.pt", "portuas.com",
];

// Returns a browser-safe image URL. Source-site photos go through the backend
// proxy (which sends the correct Referer and caches on disk); everything else
// (e.g. Unsplash placeholders, data URIs) is returned unchanged.
// `width` (160 | 480) requests a resized WebP thumbnail for list views.
export function imgProxy(url, width) {
  if (!url || typeof url !== "string") return "";
  if (url.startsWith("data:")) return url;
  try {
    const host = new URL(url).hostname.toLowerCase();
    const match = PROXY_ROOTS.some((d) => host === d || host.endsWith("." + d));
    if (match) return `${API}/img?u=${encodeURIComponent(url)}${width ? `&w=${width}` : ""}`;
  } catch (e) {
    return url;
  }
  return url;
}

export const THUMB_SM = 160;
export const THUMB_MD = 480;
